export default "__VITE_ASSET__Df_9qVpM__"